module.exports = __webpack_public_path__ + "assets/img/footer_help_btn_sp.22d0da54.svg";